import React from 'react';
import { PaletteIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-navy px-4 py-20 text-center text-white md:py-24" data-id="element-63" data-mp="3n4wducxaczp9">
      <Reveal className="mx-auto max-w-3xl" data-id="element-64" data-mp="3s039qykbd03m">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-brand-orange" data-id="element-65" data-mp="wekxfd5330u">
          <PaletteIcon className="h-6 w-6" aria-hidden="true" data-id="element-66" data-mp="2zejyigzpo0on" />
        </div>
        <h2 className="mt-6 text-3xl font-extrabold leading-tight md:text-5xl" data-id="element-67" data-mp="34c27269tgdw4">
          Bereit, jeder Klasse{' '}
          <span className="font-script italic text-brand-orange" data-id="element-68" data-mp="39an6w4l5ovk1">Kunst</span>{' '}
          näherzubringen?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/70" data-id="element-69" data-mp="3e3y4rg7zq1zt">
          10 Bände + 5 exklusive Boni — sofort einsetzbar, für nur 19 €.
        </p>
        <CTAButton animated className="mt-9 px-10 py-5" data-id="element-70" data-mp="2llkjsh7r6ai5" />
      </Reveal>
    </section>;
}